import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager } from 'ng-jhipster';

@Component({
    selector: 'jhi-legal-notice-detail',
    templateUrl: './legal-notice-detail.component.html'
})
export class LegalNoticeDetailComponent implements OnInit, OnDestroy {
    private subscription: any;
    private newsArticleSubscription;

    constructor(
        private languageService: JhiLanguageService,
        private eventManager: EventManager,
        private route: ActivatedRoute
    ) {
        this.languageService.addLocation('legalNotice');
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load();
        });
    }

    load () {
    }

    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/legal-notice/legal-notice-detail.component.ts